import { render, staticRenderFns } from "./TestYhj.vue?vue&type=template&id=208094d0&"
import script from "./TestYhj.vue?vue&type=script&lang=js&"
export * from "./TestYhj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports